import { render, staticRenderFns } from "./ClassFavorite.vue?vue&type=template&id=181ebf17&"
import script from "./ClassFavorite.vue?vue&type=script&lang=js&"
export * from "./ClassFavorite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports